/**
 * Provide Hook Form Field Errors
 *
 * This utility function extracts and provides error information for a specific field
 * in a React Hook Form structure, supporting nested fields identified using dot notation.
 *
 * @param {string} fieldId - The identifier of the field, potentially in dot notation.
 * @param {object} errors - The errors object returned by React Hook Form.
 * @returns {object} - The error object for the specified field.
 */

const provideHookFormFieldErrors = (fieldId, errors) => {
  // Check if the errors object is falsy or empty
  if (!errors || Object.keys(errors).length === 0) {
    return {}; // Return empty object if so
  }

  const fieldsList = fieldId.split('.');
  let fieldErrors = errors;

  // Iterate through fields, including nested fields
  for (let i = 0; i < fieldsList.length; i++) {
    const field = fieldsList[i];

    // Check if errors exist for this field (also finds nested errors)
    if (fieldErrors?.[field]) {
      fieldErrors = fieldErrors[field];
    } else {
      // If not found, return an empty object
      return {};
    }
  }

  // Generate the error object: Key value pair
  const errorObject = { [fieldsList[fieldsList.length - 1]]: fieldErrors };

  return errorObject;
};

export default provideHookFormFieldErrors;
